var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamMissingUpperBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_183_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.37954e-05V16.5302L3.04094 19.5712L20 19.5712V2.98781L16.9591 0C-26.4351 0 43.3864 2.37954e-05 0 2.37954e-05Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8628 0.0250005H14.8626C14.8626 0.0250133 14.8626 0.0250198 14.8626 0.0250198L14.8611 0.0250198L14.8544 0.0250197L14.7798 0.0250192L14.4183 0.0250183L12.9904 0.0250163L8.47662 0.0250119L3.96318 0.0250075L2.53578 0.0250055L2.17452 0.0250046L2.10014 0.0250041L2.09349 0.025004L2.09201 0.025004L0.025 0.0250238M14.8628 0.0250005C14.8628 0.025007 14.8628 0.0250134 14.8628 0.0250199L14.8512 0.0250201L0.025 0.0250238M14.8628 0.0250005L16.9488 0.025L19.975 2.99829V19.5462L3.05129 19.5462L0.025 16.5199M14.8628 0.0250005C14.8716 0.0163172 14.8742 0.00763443 14.874 1.97801e-08L0.025 16.5199M0.025 0.0250238V16.5199M0.025 0.0250238V16.5199",
    stroke: "url(#paint0_linear_183_8)",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8628 0.0250005H14.8626C14.8626 0.0250133 14.8626 0.0250198 14.8626 0.0250198L14.8611 0.0250198L14.8544 0.0250197L14.7798 0.0250192L14.4183 0.0250183L12.9904 0.0250163L8.47662 0.0250119L3.96318 0.0250075L2.53578 0.0250055L2.17452 0.0250046L2.10014 0.0250041L2.09349 0.025004L2.09201 0.025004L0.025 0.0250238M14.8628 0.0250005C14.8628 0.025007 14.8628 0.0250134 14.8628 0.0250199L14.8512 0.0250201L0.025 0.0250238M14.8628 0.0250005L16.9488 0.025L19.975 2.99829V19.5462L3.05129 19.5462L0.025 16.5199M14.8628 0.0250005C14.8716 0.0163172 14.8742 0.00763443 14.874 1.97801e-08L0.025 16.5199M0.025 0.0250238V16.5199M0.025 0.0250238V16.5199",
    stroke: "url(#paint1_linear_183_8)",
    strokeWidth: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_183_8",
    x: -23,
    y: -23,
    width: 66,
    height: 65.5703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_183_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_183_8",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_183_8",
    x1: -0.421547,
    y1: -2.34515,
    x2: 14.1151,
    y2: 4.06165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_183_8",
    x1: 21.4813,
    y1: 24.0318,
    x2: 14.1593,
    y2: 21.5975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMissingUpperBackground);
export default __webpack_public_path__ + "static/media/team_missing_upper_background.957e00616c5d3bdb32fd72be32e0bd56.svg";
export { ForwardRef as ReactComponent };